import { call, select, put } from 'redux-saga/effects'
import { receiveGroup } from './actions'
import { getAccessToken } from '@medeo/user'

function* rootSaga() {
  yield call(loadGroup)
}

function* loadGroup() {
  try {
    const fhirUrl = process.env.FHIR_URL
    const accessToken = yield select(getAccessToken)

    const groupRequest = yield fetch(`${fhirUrl}/groups`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
        ...(accessToken != null && { Authorization: `Bearer ${accessToken}` })
      }
    })

    const groups = yield groupRequest.json()
    yield put(receiveGroup(groups[0]))
  } catch (error) {
    console.log(error)
  }
}

export default rootSaga



// WEBPACK FOOTER //
// ./src/Group/sagas.js